module.exports = __webpack_public_path__ + "img/airport_lounge.91819a10.jpg";